<template>
  <div>
    <img :src="largeIconUrl" class="header-img" @click="lookMore" v-if="largeIconUrl" />
    <div class="header">
      <Swiper class="header-swiper"></Swiper>
      <div class="module">
        <CardHeader title="诚 · 通告" moreTitle="通知公告" icon="massage" headWidth="384px" padding="8px"></CardHeader>
        <ArticleModule :list="informList" width="384px"></ArticleModule>
      </div>
      <Video :list="videoList"></Video>
    </div>
    <div class="article">
      <div class="module" :style="{'width': '400px'}">
        <CardHeader title="诚 · 新闻" moreTitle="至诚新闻" icon="new" headWidth="400px" padding="8px"></CardHeader>
        <ArticleModule :list="newList" width="400px"></ArticleModule>
      </div>
      <div class="module" :style="{'margin': '0 16px'}">
        <CardHeader title="诚 · 服务" moreTitle="至诚服务" icon="industry" headWidth="384px" padding="8px"></CardHeader>
        <ArticleModule :list="partyList" width="384px"></ArticleModule>
      </div>
      <div class="module">
        <img
          :src="item.pictureUrl"
          v-for="(item, index) in broadsideList"
          :key="index"
          class="module-img"
          @click="goMore(item)"
        />
      </div>
    </div>
    <div class="service">
      <div
        class="service-children"
        v-for="(item, index) in serviceList"
        :key="index"
        @click="goMore(item)"
      >
        <div
          class="service-children-center"
          :style="{'border-left': index === 0 ? '0px' : '1px solid #E6E6E6'}"
        >
          <img :src="item.pictureUrl" class="service-children-icon" />
          <div class="service-children-title">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="features">
      <CardHeader title="特色项目" moreTitle="特色项目" icon="features" headWidth="100%" padding="16px"></CardHeader>
      <FeaturesSwiper :swiperList="featuresList"></FeaturesSwiper>
    </div>
    <LinkSwiper></LinkSwiper>
  </div>
</template>

<script>
import Swiper from "../../components/Swiper";
import CardHeader from "../../components/CardHeader/CardHeader-3";
import ArticleModule from "../../components/ArticleModule/ArticleModule-3";
import Video from "../../components/Video/Video-3";
import FeaturesSwiper from "../../components/FeaturesSwiper.vue";
import LinkSwiper from "../../components/LinkSwiper.vue";
let dayjs = require("dayjs");

export default {
  data() {
    return {
      largeIconUrl: "",
      informList: [],
      newList: [],
      partyList: [],
      blogrollList: [],
      broadsideList: [],
      serviceList: [],
      featuresList: [],
      videoList: [],
      largeId: null
    };
  },
  components: {
    Swiper,
    ArticleModule,
    CardHeader,
    Video,
    FeaturesSwiper,
    LinkSwiper
  },
  created() {
    this.getMenuList();
    this.getInformList();
    this.getPartyList();
    this.getNewList();
    this.getFeaturesList();
    this.getBroadsideList();
    this.getServerList();
    this.getVideoList();
    this.getInfo();
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    getInfo() {
      this.$http.get("/setting/open").then(res => {
        this.largeIconUrl = res.data.data[0].largeIconUrl;
        this.largeId = res.data.data[0].largeIconCategoryId;
      });
    },
    getVideoList() {
      this.$http.get(`/video/open?page=1&sort=rank,ASC`).then(res => {
        this.videoList = res.data.data;
      });
    },
    getBroadsideList() {
      this.$http
        .get(
          "/index-setting/open?page=1&filter=type||eq||broadside&sort=rank,ASC"
        )
        .then(res => {
          this.broadsideList = res.data.data;
        });
    },
    getServerList() {
      this.$http
        .get("/index-setting/open?page=1&filter=type||eq||string&sort=rank,ASC")
        .then(res => {
          this.serviceList = res.data.data;
        });
    },
    getMenuList() {
      this.$http.get("/open/cms/category/get-all-category").then(res => {
        let menuList = res.data.data;
        this.$store.commit("eidtAllMenuList", res.data.data);
        this.$router.push({
          name: "home",
          query: { selectMenuId: menuList[0].id }
        });
      });
    },
    goLink(link) {
      window.open(link);
    },
    lookMore() {
      this.$http
        .get(
          `/open/cms/category?filter=id||eq||${this.largeId}&filter=type||eq||nav`
        )
        .then(res => {
          this.$store.commit("eidtBreadcrumb", res.data.data[0].id);
          if (res.data.data[0].parentId) {
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then(data => {
                this.$router.push({
                  name: "articleList",
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: res.data.data[0].categoryType,
                    selectMoreId: res.data.data[0].id
                  }
                });
              });
          } else {
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: res.data.data[0].id,
                type: res.data.data[0].categoryType
              }
            });
          }
        });
    },
    async getList(name, limit) {
      let id = await this.$http
        .get(`/open/cms/category?filter=name||eq||${encodeURI(name)}`)
        .then(res => {
          if (res.data.data[0]) {
            return res.data.data[0].id;
          }
        });
      let list = await this.$http
        .get(`/open/cms/article?filter=categoryId||eq||${id}&limit=${limit}`)
        .then(res => {
          return res.data.data;
        });
      list.forEach(item => {
        item.createdAt = dayjs(new Date(item.createdAt)).format("YYYY-MM-DD");
      });
      return list;
    },
    async getInformList() {
      this.informList = await this.getList("通知公告", 3);
    },
    async getPartyList() {
      this.partyList = await this.getList("至诚服务", 5);
    },
    async getNewList() {
      this.newList = await this.getList("至诚新闻", 5);
    },
    async getFeaturesList() {
      this.featuresList = await this.getList("特色项目", 100);
    },
    goMore(item) {
      this.$http
        .get(
          `/open/cms/category?filter=id||eq||${item.categoryId}&filter=type||eq||nav`
        )
        .then(res => {
          if (res.data.data[0].parentId) {
            this.$store.commit("eidtBreadcrumb", item.categoryId);
            this.$http
              .get(
                `/open/cms/category?filter=id||eq||${res.data.data[0].parentId}`
              )
              .then(data => {
                this.$router.push({
                  name: "articleList",
                  query: {
                    selectMenuId: data.data.data[0].id,
                    type: res.data.data[0].categoryType,
                    selectMoreId: res.data.data[0].id
                  }
                });
              });
          } else {
            this.$router.push({
              name: "articleList",
              query: {
                selectMenuId: res.data.data[0].id,
                type: res.data.data[0].categoryType
              }
            });
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: 500px;
  &-swiper {
    width: 800px;
    height: 500px;
    margin-right: 16px;
    overflow: hidden;
    float: left;
  }
  &-img {
    width: 1200px;
    display: block;
    margin-bottom: 16px;
    cursor: pointer;
  }
}
.article {
  margin-top: 16px;
  height: 248px;
  &-chunk {
    @extend .article;
    height: 440px;
  }
}
.module {
  float: left;
  width: 384px;
  background: #fff;
  &-main {
    margin-top: 16px;
  }
  &-larger {
    float: right;
    background: #fff;
    width: 830px;
    margin-left: 16px;
  }
  &-img {
    width: 384px;
    display: block;
    cursor: pointer;
  }
}
.service {
  margin-top: 16px;
  height: 160px;
  background: white;
  text-align: center;
  color: #313233;
  &-children {
    float: left;
    width: 133px;
    height: 160px;
    position: relative;
    &-center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
      &:hover {
        color: #ff9240;
      }
    }
    &-icon {
      width: 34px;
      height: 34px;
    }
  }
}
.features {
  margin-top: 16px;
  height: 290px;
  background: white;
}
</style>
